import { render, staticRenderFns } from "./SendToStep.vue?vue&type=template&id=b42c038e&scoped=true"
import script from "./SendToStep.vue?vue&type=script&lang=ts"
export * from "./SendToStep.vue?vue&type=script&lang=ts"
import style0 from "./SendToStep.vue?vue&type=style&index=0&id=b42c038e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42c038e",
  null
  
)

export default component.exports